import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const Twitter: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            version="1.1"
            id="svg5"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 23 23"
            enableBackground="new 0 0 23 23;"
            xmlSpace="preserve"
        >
            <path
                id="path1009"
                className="st0"
                fill="#FFFFFF"
                d="M2.5,3l7,9.4l-7,7.6H4l6.2-6.7l5,6.7h5.4l-7.4-9.9L19.7,3h-1.6l-5.7,6.1L7.9,3H2.5z M4.8,4.2h2.5
       l10.9,14.6h-2.5L4.8,4.2z"
            />
        </svg>
    );
};

export default React.memo(Twitter);
